import promocodes from './promocodes'
import discountcodes from './discountcodes'
import couponsca from './couponsca'
import {
  CLIENT_PROMO_CODES,
  CLIENT_DISCOUNT_CODES,
  CLIENT_COUPONS_CA,
} from './siteIds'

const APP_CONFIG = {
  [CLIENT_PROMO_CODES]: promocodes,
  [CLIENT_DISCOUNT_CODES]: discountcodes,
  [CLIENT_COUPONS_CA]: couponsca,
}

export default APP_CONFIG
